import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { LocaleService } from '../services/locale.service';

export const countryInterceptor: HttpInterceptorFn = (req, next) => {
  const localeService = inject(LocaleService);
  const country = localeService.country || 'PE';

  const cloned = req.clone({
    setHeaders: {
      'X-Country': country,
    },
  });

  return next(cloned);
};
